var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ 'background-color': `rgb(${_vm.spotColor.red}, ${_vm.spotColor.green}, ${_vm.spotColor.blue})`})})
}
var staticRenderFns = []

export { render, staticRenderFns }